<template>
  <div id="puzzle-upload-file">
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="puzzle-source-file">
        Puzzle Source File
      </label>

      <div class="col-sm-10">
        <input
          type="file"
          name="puzzles[source_file]"
          id="puzzle-source-file"
          class="form-control"
          :required="isRequired === 'true'"
          v-on:change="sourceFile"
        />
      </div>
    </div>

    <div class="alert alert-info text-center" role="alert">
      If this puzzle is an AcrossLite file, a JPZ file will be automatically generated.
    </div>
  </div>
</template>
<script>
import {
  convertBuffer, detectFile
} from 'pzl-tools'

export default {
  data () {
    return {
      playerFileExts: [
        'jpz', 'json', 'svg', 'puz', 'pzl', 'xml'
      ],
      sourceFilename: undefined
    }
  },

  props: {
    isRequired: {
      type: String,
      default: 'false'
    }
  },

  computed: {
    isPlayerCompatible () {
      const ext = this.sourceFilename.match(/\.([^.]{3,})$/)[1]
      return this.playerFileExts.includes(ext)
    }
  },

  methods: {
    sourceFile (ev) {
      this.sourceFilename = ev.target.value

      if (!this.isPlayerCompatible) {
        this.$emit('source-file-not-player-compatible', this.sourceFilename)
      } else {
        this.$emit('source-file-player-compatible')
        // Only get the first file.
        const file = ev.srcElement.files[0]
        if (!file) {
          return
        }

        let reader = new FileReader()

        reader.onloadend = (e) => {
          let buffer = e.target.result
          let byteArray = convertBuffer(buffer)

          let xw = detectFile(file)

          xw.importPuzzle(byteArray)

          this.$emit('puzzle-imported', xw)
        }

        reader.readAsArrayBuffer(file)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleUploadFile.vue